module.exports = __webpack_public_path__ + "static/media/phoneSvgDynamics.cd15d741.svg";